<div class="dialog-container sai-dialog-shell" *transloco="let t">
    <app-sai-dialog-header
        iconLigature="track_changes"
        [title]="t('Create tracker from chart')"
        (closed)="close()"
    >
        <div saiDialogHeaderSubtitle class="header-subtitle">
                    {{ t('Table') }}:
                    <strong>{{ initial.table || initial.name || '-' }}</strong>
                </div>
    </app-sai-dialog-header>

    <div class="split-body">
        <div
            class="dialog-loading-overlay"
            *ngIf="generating || confirming || loadingMetadata || loadingDates"
        >
            <div class="flex flex-col items-center gap-3">
                <mat-progress-spinner
                    mode="indeterminate"
                    diameter="52"
                ></mat-progress-spinner>
                <p
                    *ngIf="generating"
                    class="m-0 text-center text-sm text-slate-600"
                >
                    {{ t('SAI Is Generating The Tracker Query') }}
                </p>
            </div>
        </div>

        <div class="left-column">
            <form [formGroup]="form" class="flex w-full flex-col gap-3">
                <div class="grid w-full grid-cols-1 gap-x-3 gap-y-1 sm:grid-cols-2 sm:gap-y-2">
                    <mat-form-field
                        class="w-full min-w-0 fuse-mat-dense"
                        appearance="fill"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-label>{{ t('Tracker name') }}</mat-label>
                        <input matInput formControlName="name" autocomplete="off" />
                        <mat-error *ngIf="form.get('name')?.hasError('required')">
                            {{ t('Required') }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field
                        class="w-full min-w-0 fuse-mat-dense"
                        appearance="fill"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-label>{{ t('Canvas') }}</mat-label>
                        <mat-select formControlName="canvasId">
                            <mat-option value="">{{ t('None') }}</mat-option>
                            <mat-option *ngFor="let c of canvasOptions" [value]="c.id">
                                {{ c.name }}
                                <ng-container *ngIf="c.shared">
                                    ({{ t('Shared') }})
                                </ng-container>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field
                        class="w-full min-w-0 fuse-mat-dense"
                        appearance="fill"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-label>{{ t('Type') }}</mat-label>
                        <mat-select formControlName="type">
                            <mat-option *ngFor="let opt of typeList" [value]="opt.id">
                                {{ opt.value }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field
                        class="w-full min-w-0 fuse-mat-dense"
                        appearance="fill"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-label>{{ t('Period') }}</mat-label>
                        <mat-select formControlName="period">
                            <mat-option *ngFor="let s of scheduleList" [value]="s.id">
                                {{ s.value }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field
                        class="w-full min-w-0 fuse-mat-dense"
                        appearance="fill"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-label>{{ t('Threshold type') }}</mat-label>
                        <mat-select formControlName="thresholdType">
                            <mat-option value="">{{ t('None') }}</mat-option>
                            <mat-option value="max">{{ t('Max') }}</mat-option>
                            <mat-option value="min">{{ t('Min') }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field
                        class="w-full min-w-0 fuse-mat-dense"
                        appearance="fill"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-label>{{ t('Threshold') }}</mat-label>
                        <input matInput formControlName="threshold" type="text" />
                    </mat-form-field>

                    <mat-form-field
                        class="w-full min-w-0 fuse-mat-dense"
                        appearance="fill"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-label>{{ t('Metric columns') }}</mat-label>
                        <input
                            matInput
                            formControlName="metricColumnsText"
                            [placeholder]="t('Comma-separated column names')"
                        />
                    </mat-form-field>

                    <mat-form-field
                        class="w-full min-w-0 fuse-mat-dense"
                        appearance="fill"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-label>{{ t('Date column') }}</mat-label>
                        <mat-select
                            formControlName="dateColumn"
                            (selectionChange)="onDateColumnSelected($event.value)"
                        >
                            <mat-option
                                *ngFor="let opt of dateColumnOptions"
                                [value]="opt.value"
                            >
                                {{ opt.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field
                        class="w-full min-w-0 fuse-mat-dense"
                        appearance="fill"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-label>{{ t('Start date') }}</mat-label>
                        <input
                            matInput
                            formControlName="start_date"
                            [matDatepicker]="startDatePicker"
                            [min]="minDate"
                            [max]="maxDate"
                            [placeholder]="t('Start date')"
                            (focus)="startDatePicker.open()"
                            (click)="startDatePicker.open()"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="startDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field
                        class="w-full min-w-0 fuse-mat-dense"
                        appearance="fill"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-label>{{ t('End date') }}</mat-label>
                        <input
                            matInput
                            formControlName="end_date"
                            [matDatepicker]="endDatePicker"
                            [min]="minDate"
                            [max]="maxDate"
                            [placeholder]="t('End date')"
                            (focus)="endDatePicker.open()"
                            (click)="endDatePicker.open()"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="endDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </form>
        </div>

        <div class="right-column">
            <div
                *ngIf="!generatedQuery && !hasPreviewData"
                class="preview-placeholder"
            >
                <mat-icon class="preview-placeholder-icon">insights</mat-icon>
                <p class="preview-placeholder-text">
                    {{
                        t(
                            'Generate and execute to preview how your tracker chart will look'
                        )
                    }}
                </p>
            </div>

            <ng-container
                *ngIf="
                    trackerType === 1 || trackerType === 2 || trackerType === 3;
                    else singleValuePreview
                "
            >
                <div
                    *ngIf="hasPreviewData"
                    class="flex w-full flex-col gap-4"
                >
                    <div class="flex-1 min-w-0" *ngIf="queryChartData">
                        <h2 class="preview-section-title">
                            {{ t('Generated Chart') }}
                        </h2>
                        <div
                            class="preview-chart-card w-full bg-card shadow-lg rounded-xl p-4 border border-gray-200 dark:border-gray-700"
                        >
                            <p
                                class="mb-4 text-gray-700 dark:text-gray-300 text-center font-semibold text-lg"
                            >
                                {{
                                    form.get('name')?.value ||
                                        (queryChartData.xAxis || 'X-Axis') +
                                            ' vs ' +
                                            (queryChartData.yAxis || 'Y-Axis')
                                }}
                            </p>
                            <app-dynamic-charts
                                [chartData]="queryChartData"
                                class="w-full tracker-preview-chart"
                                [chartTitle]="''"
                                [currentIndex]="0"
                                [from]="''"
                                [hideTitle]="true"
                            ></app-dynamic-charts>
                        </div>
                    </div>

                    <div class="flex-1 min-w-0" *ngIf="queryHeaders.length > 0">
                        <h2 class="preview-section-title">
                            {{ t('Result Data') }}
                        </h2>
                        <fuse-card class="flex flex-col">
                            <div class="overflow-auto max-h-[220px] rounded-xl">
                                <table class="min-w-full preview-result-table">
                                    <thead>
                                        <tr>
                                            <th
                                                *ngFor="
                                                    let header of queryHeaders;
                                                    trackBy: trackByHeader
                                                "
                                            >
                                                {{ header }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="
                                                let row of queryData;
                                                trackBy: trackByRow
                                            "
                                        >
                                            <td *ngFor="let cell of row">
                                                {{ cell }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </fuse-card>
                    </div>
                </div>
            </ng-container>

            <ng-template #singleValuePreview>
                <div
                    *ngIf="trackerType === 4 && singleValueTracker.length > 0"
                    class="grid grid-cols-1 gap-4"
                >
                    <div
                        *ngFor="let item of singleValueTracker"
                        class="single-value-card"
                    >
                        <div class="single-value-name">{{ item.name }}</div>
                        <div class="single-value-amount">
                            {{ _functionsService.formatNumber(item.value) }}
                        </div>
                        <div *ngIf="item.measure" class="single-value-measure">
                            {{ item.measure }}
                        </div>
                    </div>
                </div>
            </ng-template>

            <div *ngIf="generatedQuery" class="generated-block">
                <p class="generated-heading">{{ t('Generated Query') }}</p>
                <div class="generated-scroll">
                    <div
                        class="generated-text"
                        [innerHTML]="markDownContent(generatedQuery)"
                    ></div>
                </div>
            </div>

            <div *ngIf="explanationQuery" class="generated-block">
                <p class="generated-heading">{{ t('Query Explanation') }}</p>
                <div class="generated-scroll">
                    <div
                        class="generated-text"
                        [innerHTML]="markDownContent(explanationQuery)"
                    ></div>
                </div>
            </div>
        </div>
    </div>

    <div class="dialog-footer">
        <button
            type="button"
            class="max-sm:w-full"
            mat-button
            (click)="close()"
            [disabled]="generating || confirming"
        >
            {{ t('Cancel') }}
        </button>

        <button
            *ngIf="hasPreviewData"
            type="button"
            class="max-sm:w-full"
            mat-stroked-button
            (click)="backToConfigure()"
            [disabled]="confirming || generating"
        >
            {{ t('Back') }}
        </button>

        <button
            *ngIf="!hasPreviewData"
            type="button"
            class="max-sm:w-full"
            mat-flat-button
            [class.bg-primary]="!generating && !form.invalid"
            [class.bg-invalid]="generating || form.invalid"
            [disabled]="generating || form.invalid"
            (click)="generateAndExecute()"
        >
            {{
                generating
                    ? t('SAI Is Generating The Tracker Query')
                    : t('Generate And Execute')
            }}
        </button>

        <button
            *ngIf="hasPreviewData"
            type="button"
            class="max-sm:w-full"
            mat-flat-button
            [class.bg-primary]="!confirming"
            [class.bg-invalid]="confirming"
            [disabled]="confirming"
            (click)="confirmCreate()"
        >
            {{ confirming ? t('Saving...') : t('Confirm') }}
        </button>
    </div>
</div>
